module.exports = __webpack_public_path__ + "static/media/uhg-logo.1baa899d.png";